import { STRAPI_FILTER_OPERATORS } from '../../constants';

import type { FilterParamsCreator } from '../../types';

export const defineParamsCreator = (
  key: string | [string, string],
  operator: (typeof STRAPI_FILTER_OPERATORS)[keyof typeof STRAPI_FILTER_OPERATORS]
): FilterParamsCreator => {
  if (typeof key === 'string') {
    return (value) => {
      return {
        [key]: {
          [operator]: value,
        },
      };
    };
  }

  return (value) => {
    return {
      [key[0]]: {
        [key[1]]: {
          [operator]: value,
        },
      },
    };
  };
};

export default defineParamsCreator;
